import { useSelector } from "react-redux";
import { Navigate, Outlet, useLocation } from "react-router-dom";

import { RootState, store } from "@store/store";
import { Permission } from "@interfaces/users";

const hasPermission = (permissions: Array<Permission>, scopes: Array<string>) => {
    return scopes.some((scope) => permissions.some((permission) => permission.module.code === scope));
};

export default function RutaProtegida(props: Partial<{ permissionCodes: Array<string> }>) {
    const location = useLocation();

    const authState = useSelector((state: RootState) => state.session.auth);
    const permissions = (state = store.getState()) => state.session.permissions;

    if (
        props.permissionCodes !== undefined &&
        hasPermission(permissions(store.getState()), props.permissionCodes) === false
    ) {
        return <Navigate to={location.state?.from?.pathname || "/"} replace />;
    }

    if (authState.isAuthenticate === false || authState.isVerified === false) {
        return <Navigate to="/" replace />;
    }

    return <Outlet />;
}
